import { liveStatsVuexGetters } from '@ahaslides-product/frontend-toolkit'
import { isFeatureEnabled, isPresentationCreatedAfterTurnOnFlag } from '../featureToggles.module'
import config from '@/config'

const _getters = {
  ...liveStatsVuexGetters,

  canUseKvSyncLiveStats: (_, __, ___, rootGetters) => {
    return isPresentationCreatedAfterTurnOnFlag(rootGetters, 'kv-sync-emqx-for-live-stats') &&
      isFeatureEnabled(rootGetters, 'kv-sync-emqx-for-live-stats')
  },
  canUseWordCloudEmqx: (_, getters, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'presenter-wordcloud-emqx') &&
      isFeatureEnabled(rootGetters, 'audience-wordcloud-emqx') &&
      isPresentationCreatedAfterTurnOnFlag(rootGetters, 'audience-wordcloud-emqx') &&
      getters.canUseKvSyncLiveStats
  },
  canUsePollEmqx: (_, getters, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'presenter-poll-emqx') &&
      isFeatureEnabled(rootGetters, 'audience-poll-emqx') &&
      isPresentationCreatedAfterTurnOnFlag(rootGetters, 'audience-poll-emqx') &&
      getters.canUseKvSyncLiveStats
  },
  canUseScaleEmqx: (_, getters, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'presenter-scale-emqx') &&
      isFeatureEnabled(rootGetters, 'audience-scale-emqx') &&
      isPresentationCreatedAfterTurnOnFlag(rootGetters, 'audience-scale-emqx') &&
      getters.canUseKvSyncLiveStats
  },
  canUseReactionEmqx: (_, getters, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'presenter-reaction-emqx') &&
      isFeatureEnabled(rootGetters, 'audience-reaction-emqx') &&
      isPresentationCreatedAfterTurnOnFlag(rootGetters, 'audience-reaction-emqx') &&
      getters.canUseKvSyncLiveStats
  },
  canUseNewChangeSlideMechanism: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'AHA-30192-presenter-change-slide')
  },
  canUpdateSlideThroughProxy: (_, __, ___, rootGetters) => {
    if (config.env == 'local') {
      return false
    }
    return isFeatureEnabled(rootGetters, 'presenter-update-slide-through-proxy')
  },
}

export default _getters
